import { Injectable } from '@angular/core';
import { ApiService } from '../../../../_core/_services/api.service';
import { BaseEntityService } from './base-entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EndCustomerCircuitsService extends BaseEntityService<any> {
  protected endpoint = 'endcustomercircuit';

  constructor(api: ApiService) {
    super(api);
  }

  // Override addData to handle End Customer Circuit-specific logic
  override addData(data: any): Observable<any> {
    const new_value = { ...data };
    console.log('Adding End Customer Circuit:', new_value);

    return this.api.postAPI<any>('endcustomercircuit', new_value).pipe(
      map((res: any) => {
        if (res && res.body) {
          this.data.push(res.body);
          this.data$.next([...this.data]);
          console.log('End Customer Circuit data updated, current count:', this.data.length);
        }
        return res;
      })
    );
  }

  // Override updateData to handle End Customer Circuit-specific logic
  override updateData(id: number, data: any): Observable<any> {
    const new_value = { ...data };
    console.log('Updating End Customer Circuit:', { id, data: new_value });

    return this.api.putAPI<any>('endcustomercircuit', id, new_value).pipe(
      map((res: any) => {
        if (res && res.body) {
          const index = this.data.findIndex((circuit) => circuit.id === id);
          if (index !== -1) {
            this.data[index] = { ...this.data[index], ...res.body };
            this.data$.next([...this.data]);
            console.log('End Customer Circuit data updated, current count:', this.data.length);
          }
        }
        return res;
      })
    );
  }

  // Override deleteData to handle End Customer Circuit-specific logic
  override deleteData(id: number): Observable<any> {
    console.log('Deleting End Customer Circuit:', id);

    return this.api.deleteAPI<any>('endcustomercircuit', id).pipe(
      map((res: any) => {
        console.log('End Customer Circuit delete response:', res);
        const index = this.data.findIndex((circuit) => circuit.id === id);
        if (index !== -1) {
          this.data.splice(index, 1);
          this.data$.next([...this.data]);
          console.log('End Customer Circuit data updated, current count:', this.data.length);
        }
        return res;
      })
    );
  }

  // Legacy methods for backward compatibility
  getEndCustomerCircuits(queryParams?: any) {
    return this.getData(queryParams);
  }

  addEndCustomerCircuit(value: any) {
    return this.addData(value);
  }

  updateEndCustomerCircuit(id: any, value: any) {
    return this.updateData(id, value);
  }

  deleteEndCustomerCircuit(id: any) {
    return this.deleteData(id);
  }
}
